/*global _moovilaSecurity */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { Link }             from 'react-router-dom';
import { Accordion, Page }  from 'moovila-common';

import Masthead         from '../Masthead';
import APIConsoleModal  from './APIConsoleModal';

class APIConsole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionPrefix: 0,
    };
    this.resetAccordions = this.resetAccordions.bind(this);
    this.handlePrintAPIClick = this.handlePrintAPIClick.bind(this);
  }

  resetAccordions() {
    this.setState({
      accordionPrefix: this.state.accordionPrefix + 1,
    });
  }

  handlePrintAPIClick(detail=false) {
    this.props.printAPIDictionary(detail);
  }

  render() {
    const { api, method, subject, request, timer } = this.props;
    
    if (!api || !api.subjects) {
      return null;
    }

    let canRepeat10x = false;
    if (subject && request) {
      const endpoint = this.props.api.subjects.filter(sub => sub.Subject === subject)[0].APICalls.filter(call => call.Request === request)[0];
      if (endpoint.CanDoRepeatTest) {
        canRepeat10x = true;
      }
    }

    // build accordion
    const subjects = api.subjects.map((mapSubject, i) => {
      const accordionContent = mapSubject.APICalls.sort((a,b) => {
        if (a.Request < b.Request) {
          return -1;
        }
        if (a.Request > b.Request) {
          return 1;
        }
        return 0;
      }).map((mapMethod, j) => (
        <div className='accordion-group' key={j}>
          <div className='accordion-heading'>
            <Link to={`/utilities/api-console/request/${mapSubject.Subject}/${mapMethod.Request}`}>
              <div className='row'>
                <div className='col-xs-9 col-lg-10 half-gutter-r'>
                  <strong>{mapMethod.Request}</strong>
                </div>
                <div className='col-xs-3 col-lg-2 half-gutter-l text-right ellipsis'>
                  <span className='pad-left APIConsole_btnPlay'>
                    <i className='fa fa-play' />
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      ));
      return (
        <Accordion
          key={`${this.state.accordionPrefix}-${i}`}
          heading={<strong>{mapSubject.Subject}</strong>}
          content={accordionContent}
        />
      );
    });

    // main return
    return (
      <div className='APIConsole'>
        <Masthead title='API Console' icon='fa fa-bolt' />
        <Page>
          <section className='section'>
            <section className='section'>
              <div className='row'>
                <div className='col-xs-8'>
                  <h3>
                    <span className='text-primary'>Enterprise GUID:</span>
                    <span className='pad-left'>{_moovilaSecurity.GetEnterpriseGUID()}</span>
                  </h3>
                  <h3>
                    <span className='text-primary'>User GUID:</span>
                    <span className='pad-left'>{_moovilaSecurity.GetUserGUID()}</span>
                  </h3>
                  <h3>
                    <span className='text-primary'>Session GUID:</span>
                    <span className='pad-left'>{_moovilaSecurity.GetSessionGUID()}</span>
                  </h3>
                </div>
                <div className='col-xs-4 text-right' style={{position: 'relative', top: '-3px'}}>
                  <button className='btn btn-primary btn-md' onClick={() => this.handlePrintAPIClick(false)}>
                    <i className='fa fa-2x fa-plus-circle btn-icon' />
                    Print API Dictionary
                  </button>
                </div>
                <div className='col-xs-4 text-right'>
                  <button className='btn btn-primary btn-md' onClick={() => this.handlePrintAPIClick(true)}>
                    <i className='fa fa-2x fa-plus-circle btn-icon' />
                    Print API Dictionary Detail
                  </button>
                </div>
              </div>
            </section>
            <section className='section'>
              <div className='row'>
                <div className='col-xs-12 accordion inverse'>
                  { subjects }
                </div>
              </div>
            </section>
          </section>
        </Page>
        <APIConsoleModal
          api={api}
          method={method}
          subject={subject}
          request={request}
          canRepeat10x={canRepeat10x}
          timer={timer}
          executeAPITest={this.props.executeAPITest}
          executeAPITest10x={this.props.executeAPITest10x}
          response={this.props.response}
          results={this.props.results}
          isCached={this.props.isCached}
        />
      </div>
    );
  }
}

export default APIConsole;



// WEBPACK FOOTER //
// ./src/components/Utilities/APIConsole.js